import { Backdrop } from "@mui/material";
import React from "react";
import { useState } from "react";
import { common_axios } from "../../../App";
import Swal from "sweetalert2";

import Loader from "../../../components/Loader";
import "../../../../src/assetsrewards/css/material-dashboard.css";
import moment from "moment";
import RewardsFileExampleFile from "./RewardsFileExampleFile";
import { Link } from "react-router-dom";
import file2 from "../../../../src/file/Book1.xlsx";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { toast } from "react-toastify";

export default function Config() {
  const [file, setFile] = useState([]);
  const [open, setOpen] = useState(false);
  const [fileexten, setfileexten] = useState("");

  const handleChange = (e) => {
    setFile(e.target.files[0]);
  };

  // console.log(file?.name.split(".")[1]);

  console.log({ file });

  const fileext = file?.name;

  const extesion = fileext?.substring(fileext.lastIndexOf(".") + 1);

  console.log({ fileext });
  console.log({ extesion });

  // var x = "1.2.2.2.txt";
  // alert(x.substring(x.lastIndexOf(".") + 1));

  // function getFileExtension(file) {
  //   // get file extension
  //   console.log(file);
  //   const extension = file?.name;
  //   console.log({ extension });
  //   return extension;
  // }

  // getFileExtension();

  // getExtension(console.log(file), console.log(file.name.split(".")[1]));

  const rewardProduct = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
    try {
      if (extesion != "xlsx") {
        e.target.reset();
        // return await toast.error("Please Select Excel File", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          //  title: "Oops...",
          text:"Please Select Excel File",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_REWARDS}/reward/v1/product/create`,
        formData
      );

      if (res.data.statusDescription.statusCode == 200) {
        e.target.reset();
        setOpen(false);
        await setFile();
        // await toast.success("File uploaded", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "File uploaded",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        e.target.reset();
        Swal.fire({
          icon: "error",
          //  title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      e.target.reset();
      setOpen(false);
      await setFile();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg p-4">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div class="card p-0">
          <div class="card-header p-3 pt-2">
            <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
              <ShoppingCartIcon sx={{ color: "white", fontSize: "33px" }} />
            </div>
            <div class="pt-1">
              <p
                class="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                style={{ marginLeft: " 70px" }}
              >
                Config Rewards
              </p>
              <p class="text-sm mb-0  text-capitalize d-inline-block float-end">
                Field(s) marked with <span class="text-danger fw-bold">*</span>{" "}
                are mandatory.
              </p>
            </div>
          </div>
          <div className="card-body">
            <div className="card shadow-none border bg_blue">
              <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                Configuration
              </span>
              <div className="card-body">
                <form onSubmit={rewardProduct}>
                  <div className=" d-flex justify-content-betwee align-items-center">
                    <input
                      required
                      type="file"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      style={{
                        border: "1px solid rgb(210,214,218)",
                        padding: "3px",
                      }}
                      onChange={handleChange}
                    />

                    <div className="d-flex align-items-center ms-4">
                      {/* <div class="col-md-3">
              <div class="form-check"> */}
                      <button
                        type="submit"
                        class="btn w_auto bg-gradient-primary uploadcard upload m-0 ms-4"
                        style={{
                          width: "auto !important",
                          padding: "13px !important",
                        }}
                      >
                        Upload{" "}
                        <i class="material-icons opacity-10">file_upload</i>
                      </button>
                      {/* </div>
            </div> */}
                    </div>
                  </div>

                  <div className="mt-2">
                    <a
                      href={file2}
                      target="_blank"
                      download="Reference.xlsx"
                      className="text-info"
                    >
                      (Sample Here.) .xlsx
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
